import { useState } from "react";
import { v4 } from "uuid";

import { isUnitTest } from "@citrine/configuration";

let idCounter = 0;
const getUniqueId = () => (isUnitTest ? `unique-id:${idCounter++}` : v4());

export function useUniqueId(id?: string) {
  return useState(id || getUniqueId)[0];
}
